export default [{
        path: '/almacen-documentos/buscar-documento',
        name: 'almacen-documentos-buscar',
        component: () =>
            import ('@/views/pages/almacenDocumentos/BuscarDocumentos.vue'),
        meta: {
			title: 'i18n:',
            resource: 'Almacen Documentos',
            action: 'ver-almacen-documentos-buscar-documento',
            pageTitle: 'Buscar Documentos',
            breadcrumb: [{
                text: 'Buscar Documentos',
                active: true,
            }, ],
        },
    },

    {
        path: '/almacen-documentos/mantenimiento-almacen',
        name: 'mantenimiento-almacen',
        component: () =>
            import ('@/views/pages/almacenDocumentos/MantenimientoAlmacen.vue'),
        meta: {
			title: 'i18n:',
            resource: "Almacen Documentos",
            action: "ver-almacen-mantenimiento-almacen",
            pageTitle: 'Mantenimiento de Almacén',
            breadcrumb: [{
                text: 'Mantenimiento de Almacén',
                active: true,
            }, ],
        },
    },

    {
        path: '/almacen-documentos/gestion-archivos',
        name: 'gestion-archivos',
        component: () =>
            import ('@/views/pages/almacenDocumentos/GestionArchivos.vue'),
        meta: {
			title: 'i18n:',
            resource: "Almacen Documentos",
            action: "ver-almacen-gestion-archivo",
            pageTitle: 'Gestión de Archivos',
            breadcrumb: [{
                text: 'Gestión de Archivos',
                active: true,
            }, ],
        },
    },

    {
        path: '/almacen-documentos/permisos-usuarios',
        name: 'permisos-usuarios',
        component: () =>
            import ('@/views/pages/almacenDocumentos/ConfiguracionPermisos.vue'),
        meta: {
			title: 'i18n:',
            resource: "Almacen Documentos",
            action: "ver-almacen-configuracion-permisos",
            pageTitle: 'Configuracion Permisos',
            breadcrumb: [{
                text: 'Configuracion Permisos',
                active: true,
            }, ],
        },
    },

    {
        path: '/almacen-documentos/permisos-almacen',
        name: 'permisos-almacen',
        component: () =>
            import ('@/views/pages/almacenDocumentos/PermisoAlmacen.vue'),
        meta: {
			title: 'i18n:',
            resource: "Almacen Documentos",
            action: "ver-almacen-configuracion-permisos-almacen",
            pageTitle: 'Permisos Almacen',
            breadcrumb: [{
                text: 'Permisos Almacen',
                active: true,
            }, ],
        },
    },

]
